export interface CustomLevelsType {
  terrible: 100;
}

export const CustomLevels: CustomLevelsType = {
  terrible: 100,
};
